<nsa-modal *transloco="let transloco">
  <div modal-header-icon class="modal-avatar">{{ initials() }}</div>

  <ng-container modal-body>
    <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <nsa-input
        nsaId="nsf-profile-name-id"
        nsaName="nsf-profile-name"
        label="HEADER.PROFILE.MODAL.NAME"
        [clearable]="false"
        [cardView]="true"
        [ngModel]="data?.user?.name || '-'">
      </nsa-input>

      <nsa-input
        nsaId="nsf-profile-lastname-id"
        nsaName="nsf-profile-lastname"
        label="HEADER.PROFILE.MODAL.LASTNAME"
        [clearable]="false"
        [cardView]="true"
        [ngModel]="data?.user?.lastname || '-'">
      </nsa-input>

      <nsa-input
        nsaId="nsf-profile-email-id"
        nsaName="nsf-profile-email"
        label="HEADER.PROFILE.MODAL.EMAIL"
        [clearable]="false"
        [cardView]="true"
        [ngModel]="data?.user?.email || '-'">
      </nsa-input>

      <nsa-input
        nsaId="nsf-profile-role-id"
        nsaName="nsf-profile-role"
        label="HEADER.PROFILE.MODAL.ROLE"
        [clearable]="false"
        [cardView]="true"
        [ngModel]="data?.user?.role?.name || '-'">
      </nsa-input>

      <nsa-input
        nsaId="nsf-profile-business-area-id"
        nsaName="nsf-profile-business-area"
        label="USERS_MANAGEMENT.BUSINESS_AREA.LABEL"
        [clearable]="false"
        [cardView]="true"
        [ngModel]="data?.user?.businessArea?.name || '-'">
      </nsa-input>

      <nsa-input
        nsaId="nsf-profile-expertise-center-id"
        nsaName="nsf-profile-expertise-center"
        label="USERS_MANAGEMENT.EXPERTISE_CENTER.LABEL"
        [clearable]="false"
        [cardView]="true"
        [ngModel]="data?.user?.competenceCenter?.name || '-'">
      </nsa-input>
    </div>

    <div class="mt-6 pt-5 border-t border-line flex items-center justify-end gap-4">
      <div>
        <div class="font-semibold text-sm">{{ transloco('HEADER.PROFILE.MODAL.MORE_INFO') }}</div>
        <p class="text-xs text-ink-3">{{ transloco('MY_ABSENCES.TIMEBANK.LABEL') }}</p>
      </div>

      <label>
        <input type="checkbox" class="switch" role="switch"
               aria-label="{{ transloco('HEADER.PROFILE.MODAL.MORE_INFO') }}"
               [attr.aria-checked]="moreInfo()"
               (change)="toggleMoreInfo()" />
      </label>
    </div>

    @if(moreInfo()) {
      <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
        <nsa-input
          nsaId="nsf-profile-timebank-id"
          nsaName="nsf-profile-timebank"
          label="MY_ABSENCES.TIMEBANK.LABEL"
          [clearable]="false"
          [cardView]="true"
          [ngModel]="timebank()">
        </nsa-input>
      </div>
    }
  </ng-container>
</nsa-modal>
